import { DropdownMenuContainer, DropdownMenuContent } from "./styled";
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

interface IDropdownMenuItem {
    key: string;
    text: string;
    renderItem?: (item: IDropdownMenuItem) => JSX.Element
}

interface NFTDropdownMenuProps {
    items: IDropdownMenuItem[];
    children: React.ReactNode;
    onClick?: (item: IDropdownMenuItem) => void;
    zIndex?: number;
    showArrow?: boolean;
}

const NFTDropdownMenu = (props: NFTDropdownMenuProps) => {
    return (
        <DropdownMenuContainer style={{ zIndex: props.zIndex }}>
            <span>{props.children}{props.showArrow && <FontAwesomeIcon icon={faChevronDown} size={"1x"} style={{ marginLeft: 5 }} />}</span>
            {props.items.length && <DropdownMenuContent className="DropdownMenuContent">
                {props.items.map(item => {
                    if (item.renderItem) {
                        return (<React.Fragment key={item.key}>{item.renderItem(item)}</React.Fragment>)
                    }
                    return (
                        <span key={item.key} onClick={() => props.onClick && props.onClick(item)}>{item.text}</span>
                    )
                })
                }
            </DropdownMenuContent>}
        </DropdownMenuContainer>
    )
}

export default NFTDropdownMenu;